export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-price-tag-6146d442ac840f43c2536fa1f77f9ab4.svg";